import { RootState } from 'rootReducer';

export const selectIsVerifying = (state: RootState) => state.ui.apps.survey.entry.home.isVerifying;
